/* eslint-disable react/require-default-props */
import React from 'react';
import { translate } from '@utils/i18n';
import { DeficiencyCard } from './DeficiencyCard';
import './DeficienciesGridStyles.scss';
const NS = 'features.proposals.deficiencies_step';
const t = (key) => translate(key, { namespace: NS });
export function DeficienciesGrid({ mode, rows, selectedItems, onSelectionChange, onOpenDetail, onPhotoClick, onRemove, onToggleIncludePhotos, onFirstSelectedCardRef }) {
    let firstSelectedReported = false;
    return (React.createElement("div", { className: "deficiencies-grid", role: "list", "aria-label": mode === 'linked' ? t('linked_deficiencies_grid') : t('candidate_deficiencies_grid') }, rows.map((item) => {
        const isSelected = selectedItems.includes(item.id);
        const isFirstSelected = isSelected && !firstSelectedReported;
        if (isFirstSelected)
            firstSelectedReported = true;
        return (React.createElement("div", { key: item.id, role: "listitem", ref: isFirstSelected ? onFirstSelectedCardRef : undefined },
            React.createElement(DeficiencyCard, { item: item, mode: mode, isSelected: isSelected, onOpenDetail: onOpenDetail, onPhotoClick: onPhotoClick, onSelectionChange: onSelectionChange, onRemove: onRemove, onToggleIncludePhotos: onToggleIncludePhotos })));
    })));
}
